import { defineMessages } from 'react-intl';

export default defineMessages({
  back: {
    id: 'Unknown.AdminPanel.back',
    defaultMessage: 'Back to Admin Panel'
  }
});
